import Tags from './tagComponent';

export default Tags;
